import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-simple-crud',
  templateUrl: './simple-crud.component.html',
  styleUrls: ['./simple-crud.component.scss']
})
export class SimpleCrudComponent implements OnInit {

  public pager: any = {
    'total': 0, 
    'perPage': environment.itemsPerPage, 
    'page': 1
  };

  public batchActions = [
    { 
      name: 'Edit', 
      type: 'icon', 
      icon: 'fa fa-edit', 
      action: (event) => { this.edit(event) } 
    },
    { 
      name: 'Delete', 
      type: 'icon', 
      icon: 'fa fa-remove', 
      action: (event) => { this.delete(event) } 
    },
  ];

  constructor() { }

  ngOnInit() {
  }

  edit(event) {

  }

  delete(event) {

  }
}



// WEBPACK FOOTER //
// /code/frontend/src/app/shared/simple-crud/simple-crud.component.ts